import { Component, OnInit,Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-loginaudit-export',
  templateUrl: './loginaudit-export.component.html',
  styleUrls: ['./loginaudit-export.component.scss']
})
export class LoginauditExportComponent implements OnInit {
  @Input() public Content: any;
  MonoWindowPDF: UntypedFormGroup
  public content: any;
  details_data: any;
  src: string;
  orgCode: string;
  Orgtimezone:string;
  now = new Date();
  Datestring: string;
  Printstring:string ="Login Audit Logs";
  constructor(public modalRef: NgbActiveModal, private userService: UserService, public datepipe: DatePipe,
    private commonService: UserService) {
    this.src = "../../../assets/images/logo1.png";
    this.orgCode = this.commonService.getOrgCode();

  }
  ngOnInit(): void {

   // this.Datestring = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY HH:mm:ss');
    this.details_data = [];
    this.Orgtimezone = this.userService.getLoggedUserOrgTimeZone();
    this.details_data = this.Content.content.details_data;
    let obj=this.details_data.filter(function(item){
      return item;
    })[0];

    this.Datestring  = obj.dateandtime;
    //debugger
    if( this.Content.content.username_data!="" && this.Content.content.username_data!=null &&  this.Content.content.username_data!=undefined)
         this.Printstring= this.Content.content.username_data +" Login Audit Logs";
    this.userService.getLogo(this.orgCode).subscribe(result => {
      if (result === null || result === undefined || result === '') {
        this.src = "../../../assets/images/logo1.png";
      }
      else {
        if (result.FileExt == 'svg') {
          this.src = 'data:image/svg+xml;base64,' + result.Image;
        }
        else {
          this.src = 'data:image/png;base64,' + result.Image;
        }
      }
    });
  }

  closePopup() {
    this.modalRef.dismiss();
  }

}
